/* eslint-disable */
import React from "react";
import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import SidebarCard from "components/sidebar/components/SidebarCard";
import routes from "routes";

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Navegación lateral.
 *
 * Ancho fijo de 264px y ritmo vertical constante (antes el bloque del título
 * dependía de `h-2.5` + `mt-[50px]` + `mt-[58px]`, que se desalineaba solo).
 * El logo del club baja al pie como firma, sin competir con la navegación.
 */
const Sidebar: React.FC<SidebarProps> = ({ open, onClose }) => {
  return (
    <>
      {/* Scrim: sólo en mobile/tablet, donde el sidebar se superpone al contenido */}
      <div
        className={`app-scrim fixed inset-0 z-40 transition-opacity duration-200 xl:hidden ${
          open ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
        onClick={onClose}
        aria-hidden="true"
      />

      <aside
        className={`
          fixed inset-y-0 left-0 !z-50 flex w-[264px] select-none flex-col
          border-r border-gray-200/80 bg-white transition-transform duration-300 ease-premium
          dark:border-white/10 dark:!bg-navy-800 dark:text-white
          md:!z-50 lg:!z-50 xl:!z-0
          ${open ? "translate-x-0" : "-translate-x-full"}
        `}
      >
        {/* Marca */}
        <div className="flex h-16 shrink-0 items-center justify-between border-b border-gray-200/80 px-5 dark:border-white/10">
          <div className="font-poppins text-[15px] font-bold uppercase tracking-[0.06em] text-gray-900 dark:text-white">
            <span className="text-brand-500">Estadísticas</span>{" "}
            <span className="font-medium text-gray-700 dark:text-gray-300">
              GRUN
            </span>
          </div>

          <button
            type="button"
            aria-label="Cerrar menú"
            className="-mr-1 flex h-8 w-8 items-center justify-center rounded-control text-gray-700 transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/10 xl:hidden"
            onClick={onClose}
          >
            <HiX className="h-4 w-4" />
          </button>
        </div>

        {/* Navegación */}
        <nav className="flex-1 overflow-y-auto px-3 py-5">
          <p className="px-3 pb-2 text-[11px] font-semibold uppercase tracking-[0.09em] text-gray-600 dark:text-gray-500">
            Navegación
          </p>
          <ul className="space-y-1">
            <Links routes={routes} />
          </ul>
        </nav>

        {/* Firma del club */}
        <div className="flex shrink-0 justify-center border-t border-gray-200/80 py-5 dark:border-white/10">
          <SidebarCard />
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
